import React, { PureComponent } from "react";

import { Fader } from "@formant/ui/component/common/Fader";

import * as styles from "./ModuleMessage.scss";

export interface IModuleMessageProps {
    visible: boolean;
    slow?: boolean;
    children?: React.ReactNode;
}

export class ModuleMessage extends PureComponent<IModuleMessageProps> {
    public render() {
        const { visible, slow, children } = this.props;

        return (
            <Fader
                visible={visible}
                slow={slow}
                className={styles["module-message"]}
            >
                {children}
            </Fader>
        );
    }
}
